import { useEffect } from 'react';

import { AutoLinkNode } from '@lexical/link';
import { AutoLinkPlugin } from '@lexical/react/LexicalAutoLinkPlugin';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin';
import { $getSelection } from 'lexical';

import { $createTrackingLinkNode } from './tracking-link-node';

const URL_MATCHER =
  /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

const MATCHERS = [
  (text: string) => {
    const match = URL_MATCHER.exec(text);
    if (match === null) {
      return null;
    }
    const fullMatch = match[0];
    return {
      index: match.index,
      length: fullMatch.length,
      text: fullMatch,
      url: fullMatch.startsWith('http') ? fullMatch : `https://${fullMatch}`,
      // attributes: { rel: 'noreferrer', target: '_blank' }, // Optional link attributes
    };
  },
];

export function TrackingLinkPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const removeTransform = editor.registerNodeTransform(AutoLinkNode, (node) => {
      const selection = $getSelection();
      const childrenKeys = node.getChildrenKeys();

      const isTyping = selection?.getNodes().some((selectedNode) => {
        const selectionKey = selectedNode.__key;
        return childrenKeys.includes(selectionKey) || selectionKey === node.__key;
      });

      if (!isTyping) {
        const trackingLinkNode = node.replace($createTrackingLinkNode(node.getURL()));
        trackingLinkNode.selectNext();
      }
    });

    return () => {
      removeTransform();
    };
  }, [editor]);

  return (
    <>
      <LinkPlugin />
      <AutoLinkPlugin matchers={MATCHERS} />
    </>
  );
}
